import React from 'react';
import ReactDOM from 'react-dom';

import Page from 'pages/Page';
import Hero from 'containers/Hero.container';
import About from 'containers/About.container';
import Services from 'containers/Services.container';
import Contact from 'containers/Contact.container';

const sectionComps = {
  "INFO": About,
  "SERVICES": Services,
  "CONTACT": Contact
};

function renderSection(section, i) {
  return React.createElement(sectionComps[section.type], { key: i, id: section.type });
}

export default class Home extends React.Component {

  componentDidMount() {
    if (this.props.location.hash) {
      const sectionEl = ReactDOM.findDOMNode(this).querySelector(`${this.props.location.hash}`);
      sectionEl && sectionEl.scrollIntoView();
    }
  }

  render() {
    const { sections, pageTitle } = this.props;

    return (
      <Page title={pageTitle}>
        <div className="home">
          <Hero />
          {sections.map(renderSection)}
        </div>
      </Page>
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/Home.js